<template>
  <v-container fluid="fluid">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Filters</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn>
          </template>
          <span>Reset</span>
        </v-tooltip>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Fetch Data</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-layout row="row" wrap="wrap">
          <v-flex xs12="xs12" sm6="sm6">
            <VueCtkDateTimePicker
              v-model="setDate"
              label="Select Date Range"
              range="range"
              @input="setDateTime"
            ></VueCtkDateTimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Refund History</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small color="success" @click="downloadCSV">Download CSV</v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            clearable="clearable"
            single-line="single-line"
            hide-details="hide-details"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="ml-3">
          <v-select
            v-model="recurlyFilter"
            :items="recurlyFilterOptions"
            label="Recurly Status"
            hide-details="hide-details"
          ></v-select>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="filteredItems"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.createdAt | formatDate }}</td>
            <td class="text-xs-left">{{ props.item.storeID }}</td>
            <td class="text-xs-left">
              <a @click="openLocation(props.item)">{{ props.item.CSPID }}</a>
            </td>
            <td class="text-xs-left">{{ props.item.businessName }}</td>
            <td class="text-xs-right">{{ props.item.refundAmount | currency }}</td>
            <td class="text-xs-right">{{ props.item.priorBalance | currency }}</td>
            <td class="text-xs-right">{{ props.item.newBalance | currency }}</td>
            <td class="text-xs-left">{{ props.item.promotionId }}</td>
            <td class="text-xs-center" :class="props.item.isDuplicate ? 'red--text font-weight-bold' : ''">
              {{ props.item.isDuplicate ? 'Yes' : '-' }}
            </td>
            <td class="text-xs-left">{{ props.item.recurlyID || '-' }}</td>
          </tr>
        </template>
        <template slot="footer">
          <td colspan="4" class="text-xs-right">Total Refunded:</td>
          <td class="text-xs-right">{{ totalRefunded | currency }}</td>
          <td colspan="5"></td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import smsReportsService from '../service'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'refund-history',
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(12, 'months'),
        end: this.$moment(new Date()),
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD'),
        toDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      },
      headers: [
        { text: 'Date', value: 'createdAt', sortable: true, width: '12%' },
        { text: 'Store ID', value: 'storeID', sortable: true, width: '7%' },
        { text: 'CSPID', value: 'CSPID', sortable: true, width: '8%' },
        { text: 'Business Name', value: 'businessName', sortable: true },
        { text: 'Refund', value: 'refundAmount', sortable: true, width: '8%' },
        { text: 'Prior Balance', value: 'priorBalance', sortable: true, width: '8%' },
        { text: 'New Balance', value: 'newBalance', sortable: true, width: '8%' },
        { text: 'Promo ID', value: 'promotionId', sortable: true, width: '8%' },
        { text: 'Duplicate', value: 'isDuplicate', sortable: true, width: '7%' },
        { text: 'Recurly ID', value: 'recurlyID', sortable: true, width: '12%' },
      ],
      search: null,
      items: [],
      loading: true,
      recurlyFilter: 'all',
      recurlyFilterOptions: [
        { text: 'All', value: 'all' },
        { text: 'Has Recurly', value: 'has' },
        { text: 'No Recurly', value: 'none' },
      ],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'createdAt',
        descending: true,
      },
    }
  },
  components: {
    VueCtkDateTimePicker,
  },
  filters: {
    formatDate(value) {
      if (!value) return ''
      return new Date(value).toLocaleString()
    },
  },
  computed: {
    filteredItems() {
      if (this.recurlyFilter === 'has') {
        return this.items.filter((item) => item.recurlyID)
      }
      if (this.recurlyFilter === 'none') {
        return this.items.filter((item) => !item.recurlyID)
      }
      return this.items
    },
    totalRefunded() {
      return this.filteredItems.reduce((sum, item) => sum + Number(item.refundAmount || 0), 0)
    },
  },
  created() {
    this.getList()
  },
  methods: {
    openLocation(item) {
      this.$router.push({ path: `/location/profile/${item.storeID}` })
    },
    reset() {
      this.setDate = {
        start: this.$moment(new Date()).subtract(12, 'months'),
        end: this.$moment(new Date()),
      }
      this.filter.fromDate = this.$moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD')
      this.filter.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getList()
    },
    setDateTime(val) {
      if (val && val.start && val.end) {
        // VueCtkDateTimePicker returns dates in 'YYYY-MM-DD HH:mm a' format
        this.filter.fromDate = this.$moment(val.start, 'YYYY-MM-DD HH:mm a').format('YYYY-MM-DD')
        this.filter.toDate = this.$moment(val.end, 'YYYY-MM-DD HH:mm a').format('YYYY-MM-DD')
        this.getList()
      }
    },
    reloadData() {
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        fromDate: this.filter.fromDate,
        toDate: this.filter.toDate,
      }
      return smsReportsService.getRefundHistory(params).then((response) => {
        this.items = response.data
        this.loading = false
        return response
      }).catch((error) => {
        this.loading = false
        console.error('Error fetching refund history:', error)
      })
    },
    downloadCSV() {
      const csvHeaders = ['Date', 'Store ID', 'CSPID', 'Business Name', 'Refund Amount', 'Prior Balance', 'New Balance', 'Promotion ID', 'Duplicate', 'Recurly ID']
      const csvRows = this.filteredItems.map((item) => [
        item.createdAt,
        item.storeID,
        item.CSPID,
        `"${(item.businessName || '').replace(/"/g, '""')}"`,
        item.refundAmount,
        item.priorBalance,
        item.newBalance,
        item.promotionId,
        item.isDuplicate ? 'Yes' : 'No',
        item.recurlyID || '',
      ])

      const csvContent = [
        csvHeaders.join(','),
        ...csvRows.map((row) => row.join(',')),
      ].join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'RefundHistory.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>
